var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({staticClass:"button is-primary",attrs:{"disabled":!_vm.client},on:{"click":function($event){return _vm.launch()}}},'button',_vm.$attrs,false),[_vm._m(0),_c('span',[_vm._v("Log in with Google")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fab fa-google"})])
}]

export { render, staticRenderFns }